var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9999 19.4118C15.1979 19.4118 19.4117 15.198 19.4117 10C19.4117 4.80202 15.1979 0.588234 9.9999 0.588234C4.80193 0.588234 0.588135 4.80202 0.588135 10C0.588135 15.198 4.80193 19.4118 9.9999 19.4118ZM15.2613 6.97442C15.5396 6.66759 15.5164 6.19328 15.2096 5.91502C14.9028 5.63676 14.4285 5.65992 14.1502 5.96675L7.7708 13.0012L5.84958 10.8827C5.57132 10.5759 5.09701 10.5527 4.79018 10.831C4.48335 11.1092 4.46019 11.5836 4.73845 11.8904L7.21523 14.6215C7.3574 14.7782 7.55917 14.8676 7.7708 14.8676C7.98242 14.8676 8.1842 14.7782 8.32636 14.6215L15.2613 6.97442Z",
    fill: "#263238"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproved);
export default __webpack_public_path__ + "static/media/Approved.0b4999ed8c507fee86276da02650e959.svg";
export { ForwardRef as ReactComponent };